enum GeoShapes {
  Point = 'Point',
  Line = 'Line',
  LineString = 'LineString',
  Polygon = 'Polygon',
  Multipoint = 'Multipoint',
  MultiLineString = 'MultiLineString',
  MultiPolygon = 'MultiPolygon'
}

export default GeoShapes;
